import { combineReducers } from 'redux';
import locationReducer from './location';
import localeReducer from 'reducers/locale';
import resourceReducer from 'reducers/resource';
import testimonialReducer from 'reducers/testimonial';
import schoolBoardReducer from 'reducers/schoolBoard';
import filtersReducer from 'reducers/filters';
import geoReducer from 'reducers/geo';

export default combineReducers({
  location: locationReducer,
  locale: localeReducer,
  resource: resourceReducer,
  testimonials: testimonialReducer,
  schoolBoardId: schoolBoardReducer,
  filters: filtersReducer,
  geo: geoReducer
});
